module.exports = __webpack_public_path__ + "static/hero-615a6bdb14e9bfb85db6f67ba2d63683.jpg";